import React from "react";

import { Box, Skeleton } from "@mui/material";

type Props = {};

const ActiveItemTableSkeleton = (props: Props) => {
	return (
		<Box>
			<Box display="flex" justifyContent="end" gap={2}>
				<Skeleton variant="rectangular" width={200} height={40} />
				<Skeleton variant="text" width={40} height={40} />
			</Box>
			{[1, 2, 3, 4, 5].map((item) => (
				<Skeleton variant="rectangular" width="100%" height={40} />
			))}
		</Box>
	);
};

export default ActiveItemTableSkeleton;
